import React from "react";
import { Outlet, useLocation } from "react-router-dom";
import Sidebar from "../../../components/shared/Sidebar";
import Topbar from "../../../components/shared/Topbar";

const NAV_ITEMS = [
  { label: "Dashboard", path: "/patient", end: true, icon: "🏠" },
  { label: "Profile", path: "/patient/profile", icon: "👤" },
  { label: "Find Doctors", path: "/patient/search-doctors", icon: "👨‍⚕️" },
  { label: "Find Diagnostics", path: "/patient/search-diagnostics", icon: "🧪" },
  { label: "Booking History", path: "/patient/booking-history", icon: "📋" },
  { label: "Payment History", path: "/patient/payment-history", icon: "💳" },
  { label: "Raise Issue", path: "/patient/issues", icon: "🆘" },
];

const PAGE_TITLES = {
  "/patient": "Dashboard",
  "/patient/profile": "My Profile",
  "/patient/search-doctors": "Find Doctors",
  "/patient/search-diagnostics": "Find Diagnostics",
  "/patient/booking-history": "Booking History",
  "/patient/payment-history": "Payment History",
  "/patient/issues": "Issues",
};

export default function PatientLayout() {
  const { pathname } = useLocation();
  const title =
    Object.entries(PAGE_TITLES).find(([key]) => pathname.startsWith(key))?.[1] ||
    "Patient Portal";

  return (
    <div className="flex min-h-screen bg-slate-50">
      <Sidebar logo="🧑‍🤝‍🧑" title="Patient Portal" navItems={NAV_ITEMS} />
      <div className="flex-1 flex flex-col overflow-hidden">
        <Topbar title={title} />
        <main className="flex-1 overflow-y-auto p-6">
          <Outlet />
        </main>
      </div>
    </div>
  );
}
